import { render, staticRenderFns } from "./payment-info.vue?vue&type=template&id=3d7a5bb4&scoped=true"
import script from "./payment-info.vue?vue&type=script&lang=js"
export * from "./payment-info.vue?vue&type=script&lang=js"
import style0 from "./payment-info.vue?vue&type=style&index=0&id=3d7a5bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7a5bb4",
  null
  
)

export default component.exports